import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';

import {
  CreateUpdateApplicationDto,
  CreateUpdateClientDto,
  UpdateAdminApplicationDto,
} from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import {
  ApplicationStatusEnum,
  ApplicationStatusObj,
} from '../../../common/pokCore/validation/enums';
import DynamicTextarea from '../../../app/components/DynamicTextarea';
import { useTranslation } from '../../../common/hooks/useTranslation';

import { ApplicationRecordSelector } from './ApplicationRecordSelector';

interface ApplicationAdminEditorStatusProps {
  id?: string;
  application: UpdateAdminApplicationDto;
  purchaserName?: string;
  positionName?: string;
  brandName?: string;
  isReadOnly?: boolean;
  propertyChange?: (
    obj: Partial<CreateUpdateClientDto | CreateUpdateApplicationDto>,
  ) => void;
}

export const ApplicationAdminEditorStatus: React.FC<
  ApplicationAdminEditorStatusProps
> = props => {
  const [application, setApplication] = useState(props.application);
  const { t, tk } = useTranslation('applicationLng');

  const applicationStatusOptions = [
    {
      value: ApplicationStatusEnum.Completed,
      label: t(ApplicationStatusObj.Completed),
    },
    {
      value: ApplicationStatusEnum.Rejected,
      label: t(ApplicationStatusObj.Rejected),
    },
  ];

  const propertyChange = (obj: Partial<UpdateAdminApplicationDto>) => {
    if (props.propertyChange) {
      props.propertyChange(obj);
    }
  };

  useEffect(() => {
    setApplication({
      ...props.application,
      applicationStatus:
        props.application.applicationStatus === ApplicationStatusEnum.New
          ? ApplicationStatusEnum.Completed
          : props.application.applicationStatus,
    });
  }, [props.application]);

  return (
    <>
      <Card className="card flex-grow-1">
        <Card.Header>{t(tk.app.applicationExecution)}</Card.Header>
        <Card.Body className="m-1">
          <div className="d-grid gap-3 mb-3">
            <FormRow controlId="applicationStatus" label={t(tk.common.status)}>
              <Select
                value={
                  application?.applicationStatus
                    ? applicationStatusOptions.find(
                        ({ value }) => application?.applicationStatus === value,
                      )
                    : null
                }
                options={applicationStatusOptions}
                onChange={option =>
                  propertyChange({
                    applicationStatus: option?.value,
                    rejectedNote: '',
                  })
                }
                isDisabled={props.isReadOnly}
              />
            </FormRow>
            {application.applicationStatus ===
              ApplicationStatusEnum.Completed && (
              <ApplicationRecordSelector
                purchaserName={props.purchaserName}
                positionName={props.positionName}
                brandName={props.brandName}
                application={application}
                propertyChange={propertyChange}
                readOnly={props.isReadOnly}
              />
            )}
            {application.applicationStatus ===
              ApplicationStatusEnum.Rejected && (
              <>
                <FormRow
                  controlId="rejectedNote"
                  label={t(tk.app.rejectedNote)}
                >
                  <DynamicTextarea
                    value={application.rejectedNote || ''}
                    onChange={e =>
                      propertyChange({
                        rejectedNote: e.target.value || '',
                      })
                    }
                    disabled={props.isReadOnly}
                  />
                </FormRow>
              </>
            )}
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
